import { Component, OnInit } from '@angular/core';
import { GlobalService } from '../../../../services/global.service';
import { ChatService } from '../../services/chat.service';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css']
})
export class NavbarComponent implements OnInit {

  constructor(
    public _globalService: GlobalService,
    public _chatService: ChatService
  ) { }

  ngOnInit() {
  }

  onMenu() {
    this._chatService.display_myprofile = true;
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/chat/sub-components/navbar/navbar.component.ts